import { http } from "../base"

export async function postAicsUsage(requestData) {
      console.log("postAicsUsage", requestData);

      const response = await http.post(
           `/tenant/post_aics_usage`,
        {
          tenant_id: requestData.id,
          aics_usage: requestData.aics_usage,
        },
        {
          headers: { 'Content-Type': 'application/json',
           }

        });
        console.log(response.data);
        // 统一处理响应格式
        if (response.data==null || response.data.code !== 200) {
          throw new Error(response.data.message || '修改密码失败');
        }
        return response.data;
}

export async function postAdminName(requestData) {
      console.log("postAdminName", requestData);

      const response = await http.post(
           `/tenant/post_admin_name`,
        {
          tenant_id: requestData.id,
          admin_name: requestData.contact_person,
        },
        {
          headers: { 'Content-Type': 'application/json',
           }

        });
        console.log(response.data);
        // 统一处理响应格式
        if (response.data==null || response.data.code !== 200) {
          throw new Error(response.data.message || '设置租户管理员姓名失败');
        }
        return response.data;
      }

export async function postEmail(requestData) {
      console.log("postEmail", requestData);

      const response = await http.post(
           `/tenant/post_email`,
        {
          tenant_id: requestData.id,
          company_email: requestData.company_email,
        },
        {
          headers: { 'Content-Type': 'application/json',
           }

        });
        console.log(response.data);
        // 统一处理响应格式
        if (response.data==null || response.data.code !== 200) {
          throw new Error(response.data.message || '设置企业邮箱失败');
        }
        return response.data;
}
export async function postInvoiceRelated(requestData) {
      console.log("postInvoiceRelated", requestData);

      const response = await http.post(
           `/tenant/post_invoice_related`,
        {
          tenant_id: requestData.id,
          bank_name: requestData.bank_name,
          bank_account: requestData.bank_account,
          reg_address: requestData.reg_address,
          company_phone: requestData.company_phone                              
        },
        {
          headers: { 'Content-Type': 'application/json',
           }

        });
        console.log(response.data);
        // 统一处理响应格式
        if (response.data==null || response.data.code !== 200) {
          throw new Error(response.data.message || '设置发票相关信息失败');
        }
        return response.data;
} 
